export default __webpack_public_path__ + "static/char-s-16-jp-85c025fc536e305ea9f9c14507fbbfc3.png";